<template>
  <div class="record-page">
    <Header :title="title"></Header>
    <div class="detail">
      <div class="info">
        总天数：{{info.checkin_total}}天 | 已打卡天数：{{info.checkin_count}}天
      </div>
      <CheckInInfo :join_user="info"></CheckInInfo>
    </div>
    <div class="lines"></div>
    <div class="recordItem">
      <p>打卡记录</p>
      <RecordItem v-for="(item,index) in detail.list"
                  :data='item'
                  :key="index"></RecordItem>
      <Empty v-if="detail.list && !detail.list.length"
             :empty_type="{name: '暂无打卡记录'}"></Empty>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header";
import List from "@/components/List";
import CheckInInfo from "@/components/checkIn/CheckInInfo";
import RecordItem from "@/components/checkIn/RecordItem";
import Empty from "@/components/Empty";

export default {
  name: "Record",
  components: {
    List,
    Header,
    CheckInInfo,
    RecordItem,
    Empty
  },
  data () {
    return {
      title: {
        name: "打卡记录"
      },
      id: null,
      detail: {},
      info: {}
    };
  },
  created () {
    this.id = this.$route.query.id;
    this.getOverview();
    this.getDetail();
  },
  methods: {
    getOverview () {
      let param = { checkin_id: this.id };
      this.$http.get(`/api/app/checkin/daily/report/overview`, param).then((res) => {
        res.avatar = res.user.avatar;
        res.nickname = res.user.nickname;
        this.info = res;
      });
    },
    getDetail () {
      let param = { checkin_id: this.id };
      this.$http.get(`/api/app/checkin/daily/report/index`, param).then((res) => {
        this.detail = res;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.record-page {
  min-height: 100vh;
  background: #ffffff;
  font-size: 24px;
  font-family: PingFang SC;
  /deep/ {
    .header {
      border-bottom: 1px solid #f6f6f6;
    }
  }
  .detail {
    padding: 30px 30px;
    padding-top: 0;
    .info {
      color: #666666;
      font-size: 28px;
      padding: 40px 0 48px 0px;
    }
  }
  .lines {
    height: 30px;
    width: 100%;
    background-color: #f6f6f6;
  }
  .recordItem {
    padding: 37px 27px;
    p {
      color: #333333;
      font-size: 32px;
      font-weight: 500;
      margin-bottom: 44px;
    }
  }
}
</style>
